import { useCallback, useEffect } from 'react';
import { SurveyActionType } from '@enums';
import {
  SurveyFormContext,
  SurveyFormStepperState,
  SurveyResponseIdentifierContext,
  SaveCompletedSurveyResponseContext,
  SaveDisqualifiedSurveyResponseContext,
} from '@containers/SurveyForm';
import { ProjectSurveyQuestion, ComplianceSurveyQuestion } from '@screens/Survey';
import { useFetchProjectSurveyForm } from '@utils/api';
import { AnimatedLoader } from 'components/ActivityIndicator';
import {
  useProjectOnboardingContext,
} from './hooks';
import styles from './styles.css';

const errorText = 'You don\'t have access to this project.';
export const SurveyTestDriveStepper = () => {
  const ctx = useProjectOnboardingContext();
  const {
    data: res,
    isLoading,
    isError,
    refetch,
  } = useFetchProjectSurveyForm({
    preview: true,
    projectId: ctx.projectId,
  }, {
    enabled: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    staleTime: Infinity,
  });

  useEffect(() => {
    refetch();
  }, [refetch]);

  const handleDisqualification = useCallback((actionType: SurveyActionType) => {
    return Promise.resolve()
    .then(() => ctx.onDisqualification(actionType));
  }, [ctx.onDisqualification]);

  const handleCompletion = useCallback(() => {
    return Promise.resolve()
    .then(ctx.next);
  }, [ctx.next]);

  const getScreenComponent = useCallback((isScreening: boolean) => {
    return isScreening
      ? ComplianceSurveyQuestion
      : ProjectSurveyQuestion;
  }, []);

  if (isError) {
    return <div className={styles.errorMsg}>{errorText}</div>;
  }

  if (isLoading || !res) {
    return <AnimatedLoader className={styles.loading}  />;
  }

  return (
    <SurveyFormContext.Provider value={res.survey}>
      <SaveCompletedSurveyResponseContext.Provider value={handleCompletion}>
        <SaveDisqualifiedSurveyResponseContext.Provider value={handleDisqualification}>
          <SurveyResponseIdentifierContext.Provider value={res.response.identifier}>
            <SurveyFormStepperState
              eql={res.eql}
              state={res.response.state}
              getQuestionScreenComponent={getScreenComponent} />
          </SurveyResponseIdentifierContext.Provider>
        </SaveDisqualifiedSurveyResponseContext.Provider>
      </SaveCompletedSurveyResponseContext.Provider>
    </SurveyFormContext.Provider>
  );
};

export default SurveyTestDriveStepper;